module.exports = __webpack_public_path__ + "img/guruh.c1afd044.svg";